export const APP_ENV = {
  apiUrl: process.env.REACT_APP_API_KEY,
};
